import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import HeadHelmet from 'components/route/HeadHelmet'
import AppContainer from 'components/layout/AppContainer'
import SiteFooter from 'components/layout/SiteFooter'
import useRouteData from 'hooks/useRouteData'
import { SITE_USER_ROOT } from 'config'
import { selectRoute, updateRoute } from 'store/route/slice'
import { useEffect } from 'react'
import { setEntryPath } from 'store/authentication/utils'
import useUserRole from 'hooks/useUserRole'
import { useAuth } from 'react-oidc-context'
import OverlayLoader from 'components/ui/OverlayLoader'
import { ClientRoute } from 'routes/client'

export default function AdminPrivilegeGuard(): JSX.Element {
  const adminRoute = useSelector(selectRoute)
  const location = useLocation()
  const dispatch = useDispatch()
  const { titleId = '', path, notEntryRoute, outsideLayout } = useRouteData()
  const entryPathEnabled = notEntryRoute !== true
  const { isGpsEditor, isLoading, isAdmin, isAdminCourseEditor } = useUserRole()
  const oicdAuth = useAuth()

  useEffect(() => {
    if (!adminRoute.path || (adminRoute.path && adminRoute.path !== path)) {
      const newPath = `${location.pathname}${location.search}`
      const payload = { path, titleId, uri: newPath }
      dispatch(updateRoute(payload))
      if (entryPathEnabled) {
        setEntryPath(newPath)
      }
    }
  }, [location, dispatch, path, titleId, adminRoute.path, entryPathEnabled])

  if (isLoading) {
    return <OverlayLoader visible={true} />
  }

  if (oicdAuth.isAuthenticated && isGpsEditor) {
    return <Navigate to={SITE_USER_ROOT} />
  }

  if (!isAdmin && !isAdminCourseEditor) {
    return <Navigate to={ClientRoute.LOGIN} />
  }

  if (outsideLayout) {
    return (
      <>
        <HeadHelmet titleId={titleId} />
        <Outlet />
      </>
    )
  }

  return (
    <>
      <HeadHelmet titleId={titleId} />
      <AppContainer>
        <Outlet />
      </AppContainer>
      <SiteFooter />
    </>
  )
}
